import { render, staticRenderFns } from "./WorkspaceSwitcher.vue?vue&type=template&id=6ca39488&scoped=true&"
import script from "./WorkspaceSwitcher.vue?vue&type=script&lang=js&"
export * from "./WorkspaceSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceSwitcher.vue?vue&type=style&index=0&id=6ca39488&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca39488",
  null
  
)

export default component.exports